import React, {useEffect} from 'react';
import {ScrollView, StyleSheet} from 'react-native';
import {observer} from 'mobx-react-lite';

import LoadingImg from '../../components/LoadingImg';
import {ProductTileHorizontal} from '../../components/ProductTile';
import ContentView from '../../components/ui-controls/layout/ContentView';
import Text from '../../components/ui-controls/Text';
import {AppRoute} from '../../models/AppRoute';
import {RouteNavigatorScreenProps} from '../../models/navigationTypes';
import {useStores} from '../../stores/use-stores';
import theme from '../../style/theme';
import {OrderLine} from '../../transport/apiServiceResponse';

const OrderViewScreen = observer(
  ({route}: RouteNavigatorScreenProps<AppRoute.ACCOUNT_ORDER_VIEW>) => {
    const {cartStore, userStore} = useStores();
    const {orderNumber} = route.params;

    useEffect(() => {
      if (userStore.isLoggedIn && cartStore.recentOrders.length === 0) {
        cartStore.loadRecentOrders();
      }
    }, [cartStore, userStore.isLoggedIn]);

    const order = cartStore.recentOrders.find(o => o.order_number === orderNumber);

    if (!order && cartStore.loadingRecentOrders) {
      return (
        <ContentView>
          <LoadingImg />
        </ContentView>
      );
    }

    if (!order) {
      return (
        <ContentView>
          <Text style={styles.heading}>Order not found</Text>
        </ContentView>
      );
    }

    const renderOrderItem = (item: OrderLine) => (
      <ProductTileHorizontal
        item={item}
        key={item.id}
        showPreviousQuantity
        testContext="order-history"
      />
    );

    return (
      <ContentView>
        <ScrollView>
          <Text style={styles.heading}>Items in Order:</Text>
          {order.order_lines.filter(ol => !ol.charge).map(renderOrderItem)}
        </ScrollView>
      </ContentView>
    );
  },
);

export default OrderViewScreen;

const styles = StyleSheet.create({
  heading: {
    fontSize: 16,
    fontWeight: '600',
    color: theme.colour.text.heading.primary,
    marginBottom: 16,
    alignSelf: 'center',
  },
});
